import { render, staticRenderFns } from "./ComplianceFormTable.vue?vue&type=template&id=3b1523c2&"
import script from "./ComplianceFormTable.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormTable.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormTable.vue?vue&type=style&index=0&id=3b1523c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports